<section class="testimonials">
  <div class="container">
    <div class="testimonials__header">
      <span class="section-tag">{{ t().test_tag }}</span>
      <h2 class="section-title">{{ t().test_title }}</h2>
    </div>

    <div class="testimonials__slider">
      <div class="testimonial-main">
        <svg class="quote-icon" width="48" height="36" viewBox="0 0 48 36" fill="none">
          <path d="M0 36V22.8C0 9.6 7.2 2.4 21.6 0l2.4 4.8C16.8 6 13.2 9.6 12 16.8H21.6V36H0zm26.4 0V22.8C26.4 9.6 33.6 2.4 48 0l2.4 4.8C43.2 6 39.6 9.6 38.4 16.8H48V36H26.4z" fill="#0066cc" opacity="0.15"/>
        </svg>

        <p class="testimonial-quote">{{ testimonials[active()].quote }}</p>

        <div class="testimonial-author">
          <div class="author-avatar" [style.background]="testimonials[active()].color">
            {{ testimonials[active()].initials }}
          </div>
          <div>
            <strong>{{ testimonials[active()].name }}</strong>
            <span>{{ testimonials[active()].role }} · {{ testimonials[active()].company }}</span>
          </div>
        </div>
      </div>

      <div class="testimonials__dots">
        @for (t of testimonials; track t.name; let i = $index) {
          <button
            class="dot"
            [class.active]="active() === i"
            (click)="setActive(i)">
          </button>
        }
      </div>

      <div class="testimonials__cards">
        @for (t of testimonials; track t.name; let i = $index) {
          <div class="t-mini-card" [class.active]="active() === i" (click)="setActive(i)">
            <div class="mini-avatar" [style.background]="t.color">{{ t.initials }}</div>
            <div>
              <strong>{{ t.name }}</strong>
              <span>{{ t.company }}</span>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</section>
